import 'ember-could-get-used-to-this/-private/functions';
export function initialize( /* application */
) {
  // application.inject('route', 'foo', 'service:foo');
}
export default {
  initialize
};